import type { MediaCategory } from './media';

export enum ImageType {
  EKG_12_LEAD,
  RIGHT_SIDED_EKG,
  POSTERIOR_EKG,
  RENAL_US,
  RIGHT_UPPER_QUADRANT_US,
  TRANSABDOMINAL_PELVIC_US,
  XR_CHEST,
  XR_ABDOMEN,
  XR_PELVIS,
  CT_HEAD_NON_CONTRAST,
  CT_HEAD_WITH_IV_CONTRAST,
  CT_ANGIO_HEAD_WITH_IV_CONTRAST,
}

export type PatientData = {
  id: string;
  name: string;
  organizationId: string;
  imagesId: string | null;
  images?: MediaCategory[] | null;
};

export const getPatientDisplay = (patient: PatientData) => {
  // return `${patient.name} (${patient.age} ${patient.gender})`;
  return `${patient.name}`;
};

export const defaultPatientData: PatientData = {
  name: '',
  id: '',
  organizationId: '',
  imagesId: '',
  images: null,
};
